const messages = {
    privacy: 'Notice of Privacy',
    service: 'Terms and Conditions',
    copyright: '© Coin Hub, 2022. All rights reserved.',
};

export default messages;
